import { api } from '../api';

export interface AuditoriaLogGeral {
  id: number;
  data_evento: string;
  usuario_id: number | null;
  recurso: string;
  acao: string;
  recurso_id?: number | string | null;
  metodo: string;
  caminho: string;
  sucesso: boolean;
  status_code: number;
}

export interface AuditoriaModificacaoLog {
  id: number;
  data_evento: string;
  recurso: string;
  recurso_id: number | string | null;
  operacao: string;
  sucesso: boolean;
  usuario_id: number | null;
  campos_alterados?: any;
}

export const auditoriaApi = {
  async listarGerais(limit = 50): Promise<AuditoriaLogGeral[]> {
    const { data } = await api.get('/auditoria/logs', { params: { limit } });
    return data.logs || [];
  },
  async listarModificacoes(limit = 50): Promise<AuditoriaModificacaoLog[]> {
    const { data } = await api.get('/auditoria/modificacoes', { params: { limit } });
    return data.logs || [];
  },
  async relatorioCompliance(): Promise<any> {
    const { data } = await api.get('/auditoria/relatorios/compliance');
    return data.dados || [];
  }
};
